###
# Provides UI for allowing the user to select a table, a column, or both.
#
# selected             (object) An object with ``table`` and ``column`` properties.
#                               Each corresponds to the ``id`` of the table or column,
#                               respectively.
# disabled             (bool)   If ``true``, display the component but prevent the
#                               user from selecting anything.
# typeFilter           (array)  If set to a non-null array of types, only columns
#                               whose type appears in the array will be displayed.
#                               (The types are set by the Schema Service--see ``types.clj``
#                               in the ``schema-core`` repo for types.) Otherwise,
#                               columns of all types are displayed.
# tableId              (int)    Sets the table id used when filtering tables by relation.
# showReferencedTables (bool)   When ``true``, only display tables which have a relation
#                               to the the table with ``tableId``.
# allowTableSelection  (bool)   If ``true``, allows the user to select a table from
#                               a list of tables.
# allowColumnSelection (bool)   If ``true``, allows the user to select a column from
#                               a list of columns. If ``allowTableSelection`` is false,
#                               then ``selected.table`` should be set.
###

angular.module('rjmNg.directives').directive 'ceTableColumnSelect', [
  () ->
    restrict:"E"
    templateUrl: "directive.ceTableColumnSelect.html"
    priority: 200
    replace: false
    scope:
      selected: '='
      disabled: '='
      tableId: '='
      typeFilter: '='
      showReferencedTables: "="
      allowTableSelection: '='
      allowColumnSelection: '='
    controllerAs: "view"
    bindToController: true
    require: "^?rjmUi"
    controller: [
      "$scope"
      "notification"
      "columnEditor"
      "StructureCache"
      (
        $scope
        notification
        columnEditor
        StructureCache
      ) ->
        view = @
        view.structure = null
        view.references = null
        view.loading = true
        view.search =
          column: ''
          table: ''
        view.tables = []
        view.columns = []
        view.dropdownButtonText = null
        

        # Whether the user has selected everything we require them to select.
        _getSelectionMade = () ->
          tableSelected = not view.allowTableSelection or view.selected.table?
          columnSelected = not view.allowColumnSelection or view.selected.column?

          return tableSelected and columnSelected

        _getEmptySelectionButtonText = () ->
          if view.allowTableSelection and view.allowColumnSelection
            return "Select a table and column"
          else if view.allowTableSelection
            return "Select a table"
          else if view.allowColumnSelection
            return "Select a column"
          else
            return undefined

        _getButtonText = () ->
          textComponents = []
          if view.allowTableSelection
            textComponents.push view.structure.tables[view.selected.table].name
          if view.allowColumnSelection
            textComponents.push view.structure.columns[view.selected.column].name

          return textComponents.join('.')

        _getAllTables = (tableMap) ->
          (value for key, value of tableMap)

        view.updateColumns = () ->
          if view.selected?.table? and view.structure?
            view.columns = columnEditor.filterColumnsByType(
              view.structure.tables[view.selected.table].columns
              view.typeFilter
            )

        view.setTables = () ->
          showReferenced = view.showReferencedTables is true
          if view.tableId? and showReferenced
            view.tables = (view.structure.tables[tableId] for tableId in view.references.getRelatedTables(view.tableId))
          else if not showReferenced
            view.tables = _getAllTables(view.structure.tables)
          else
            view.tables = []

        view.getStructure = () ->
          StructureCache.getStructureAndReferences().then(
            (result) ->
              view.structure = result.structure
              view.references = result.references
              view.updateState()
              view.updateColumns()
              view.setTables()
              view.loading = false
            , (error) ->
              notification.error "", "Error loading structure.", "data-warehouse-notifications"
              view.loading = false
          )

        view.selectTable = ($event, table) ->
          if view.allowColumnSelection
            $event.stopPropagation()

          view.selected.table = table.id
          view.selected.column = null

        view.selectColumn = (column) ->
          view.selected.column = column.id
          view.search.column = ''
          view.search.table = ''

        view.askForReference = () ->
          $scope.$emit 'showReferenceEditor'

        view.updateState = () ->
          return unless view.structure?

          if _getSelectionMade()
            view.dropdownButtonText = _getButtonText()
          else
            view.dropdownButtonText = _getEmptySelectionButtonText()

        view.filterTableType = (table) ->
          return table.type in ["view","standard","consolidated"]

        @$onInit = ->
          view.selected ?=
            table: null
            column: null

          view.getStructure()

        view
    ]
    link: (scope, elem, attrs, rjmUi) ->
      view = scope.view
      scope.$watch 'view.selected.table', () ->
        view.search.column = ''
        view.updateColumns()
        view.updateState()

      scope.$watch 'view.typeFilter', view.updateColumns

      scope.$watchGroup [
        'view.allowTableSelection'
        'view.allowColumnSelection'
        'view.selected.table'
        'view.selected.column'
      ], view.updateState

      # Listen to see if anyone has possibly updated the structure cache,
      # especially the reference editor
      scope.$on 'view.structureCacheUpdated', () ->
        view.getStructure()

      scope.$watch "view.loading", () ->
        rjmUi?.loadingUi "data-warehouse", view.loading

]
